import {ISidenavService} from './sidenav.types';
import {StateService} from 'angular-ui-router';
import {ILoginService} from '../../auth/login.service';
import {IUserApi} from '../../api/user-api.service';
import OrganizationService from '../organization/organization.service';

export default class SidenavController {
  static $inject = ['$state', 'sidenavService', 'loginService', 'userApi', '$window', 'organizationService', '$rootScope'];

  private loggedIn:boolean;
  private showUserManagement: boolean = false;

  constructor(private $state: StateService,
              private sidenavService: ISidenavService,
              private loginService: ILoginService,
              private userApi: IUserApi,
              private $window: ng.IWindowService,
              private organizationService: OrganizationService,
              private $rootScope: ng.IRootScopeService) {

    loginService.onLoginStateChange((loggedIn) => {
      this.onLoginStateChange(loggedIn);
    });
    this.loggedIn = loginService.isLoggedIn();
  }

  logOut() {
    this.$rootScope.$broadcast(ILoginService.LOGOUT_EVENT_NAME);
    this.loginService.logOutUser().then(() => {
      this.$state.go('home');
    });
    this.sidenavService.toggleLeftSidenav();
    this.$window.localStorage.removeItem('currentOrgId');
  }

  navigateTo(state:string) {
    if (state === 'organization') {
      this.organizationService.getCurrentOrgId()
        .then(id => {
          this.$state.go(state, {id: id});
        });
    } else if (state === 'account') {

      this.$state.go('user-details', {id: 'me'});
    } else {
      this.$state.go(state);
    }
    
    this.sidenavService.toggleLeftSidenav();
  }

  private onLoginStateChange(loggedIn: boolean) {
    this.loggedIn = loggedIn;
  }

}



/** WEBPACK FOOTER **
 ** ./app/hydromet/sidenav/sidenav.controller.ts
 **/